import { partial } from 'filesize';
const fileSize = partial({ base: 2, standard: 'jedec' });
export const toFileSize = (bytes) => {
    return fileSize(bytes);
};
//# sourceMappingURL=filesize.js.map